import { render, staticRenderFns } from "./TitlePosterRibbonGraphql.vue?vue&type=template&id=4f547886&scoped=true&"
import script from "./TitlePosterRibbonGraphql.vue?vue&type=script&lang=ts&"
export * from "./TitlePosterRibbonGraphql.vue?vue&type=script&lang=ts&"
import style0 from "./TitlePosterRibbonGraphql.vue?vue&type=style&index=0&id=4f547886&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f547886",
  null
  
)

export default component.exports